<template>
  <div/>
</template>

<script>
import API from '../../../api';
import gateway from '../../../services/gravityGateway';

export default {
  data() {
    return {
      requests: [],
    };
  },
  beforeMount() {
    API.http.interceptors.request.use((data) => {
      const config = data;
      config.key = (new Date()).getTime();
      this.requests.push(config.key);
      return config;
    }, err => Promise.reject(err));

    API.http.interceptors.response.use((config) => {
      this.requests.pop();
      return config;
    }, err => Promise.reject(err));
  },
  watch: {
    requests(newValue) {
      gateway.sendMessage('Widget.Loading', {
        isLoading: !!(newValue && newValue.length),
      });
    },
  },
};
</script>
